import { useMutation } from '@tanstack/react-query';
import { runJob } from '@/features/adp/services/api-service';
import type { RunJobResponse } from '@/features/adp/services/api-service.types';

type UseRunJobMutationOptions = {
  onSuccess?: (data: RunJobResponse, variables: string) => void;
  onError?: (error: Error, variables: string) => void;
};

export function useRunJobMutation(options: UseRunJobMutationOptions = {}) {
  const { onSuccess, onError } = options;

  return useMutation<RunJobResponse, Error, string>({
    mutationFn: (sessionId) => runJob(sessionId),
    onSuccess: (data, variables) => {
      onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      onError?.(error, variables);
    },
  });
}
